import script from "./UrssafDataModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UrssafDataModal.vue?vue&type=script&setup=true&lang=js"

import "./UrssafDataModal.vue?vue&type=style&index=0&id=6fbc8370&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbc8370"]])

export default __exports__